import React from "react";

import RoleAccordion from "./RoleExplainerAccordion";

interface RoleExplanations {
	role_summary: {
		en: string;
		sw: string;
	};
	what_you_will_do: {
		en: string[];
		sw: string[];
	};
	what_you_need: {
		en: string[];
		sw: string[];
	};
	how_to_apply: {
		instructions: {
			en: string;
			sw: string;
		};
		include: {
			en: string[];
			sw: string[];
		};
	};
	cta_fit_check: {
		en: string;
		sw: string;
	};
}

function RoleExplainer({ roleExplanations, loading }: { roleExplanations?: RoleExplanations; loading: boolean }) {
	const enContent =
		roleExplanations && Object.keys(roleExplanations).length > 0 ? (
			<>
				{/* Summary */}
				<h3 className="font-semibold">Summary</h3>
				<p className="mt-1">{roleExplanations.role_summary.en || "No summary provided."}</p>

				{/* What You’ll Do */}
				<h3 className="font-semibold mt-5">What You’ll Do</h3>
				<ul className="list-disc pl-5">
					{(roleExplanations.what_you_will_do.en || []).map((role, index) => (
						<li key={index}>{role || "—"}</li>
					))}
				</ul>

				{/* What You Need */}
				<h3 className="font-semibold mt-5">What You Need</h3>
				<ul className="list-disc pl-5">
					{(roleExplanations.what_you_need.en || []).map((item, index) => (
						<li key={index}>{item || "—"}</li>
					))}
				</ul>

				<hr className="mb-3 mt-3" />

				{/* How to Apply */}
				<h3 className="font-semibold">How to Apply</h3>
				<p className="mt-1">
					{roleExplanations?.how_to_apply?.instructions.en || "No application instructions provided."}
				</p>

				<h3 className="font-semibold mt-5">Include:</h3>
				<ul className="list-disc pl-5">
					{(roleExplanations?.how_to_apply?.include.en || []).map((includeItem, index) => (
						<li key={index}>{includeItem || "—"}</li>
					))}
				</ul>

				<hr className="mb-3 mt-3" />

				<p>
					<a href="#">Fit check me</a> and We will tell you how well you match the role.
				</p>
			</>
		) : (
			<p className="mt-1">No role explainer for this job.</p>
		);

	const swContent =
		roleExplanations && Object.keys(roleExplanations).length > 0 ? (
			<>
				{/* Summary */}
				<h3 className="font-semibold">Muhtasari</h3>
				<p className="mt-1">{roleExplanations.role_summary.sw || "Hakuna muhtasari uliotolewa."}</p>

				{/* What You’ll Do */}
				<h3 className="font-semibold mt-5">Majukumu yako</h3>
				<ul className="list-disc pl-5">
					{(roleExplanations.what_you_will_do.sw || []).map((role, index) => (
						<li key={index}>{role || "—"}</li>
					))}
				</ul>

				{/* What You Need */}
				<h3 className="font-semibold mt-5">Unachohitaji</h3>
				<ul className="list-disc pl-5">
					{(roleExplanations.what_you_need.sw || []).map((item, index) => (
						<li key={index}>{item || "—"}</li>
					))}
				</ul>

				<hr className="mb-3 mt-3" />

				{/* How to Apply */}
				<h3 className="font-semibold">Namna ya Kutuma Maombi</h3>
				<p className="mt-1">
					{roleExplanations?.how_to_apply?.instructions.sw || "Hakuna maelekezo ya kuomba yaliyotolewa."}
				</p>

				<h3 className="font-semibold mt-5">Jumuisha:</h3>
				<ul className="list-disc pl-5">
					{(roleExplanations?.how_to_apply?.include.sw || []).map((includeItem, index) => (
						<li key={index}>{includeItem || "—"}</li>
					))}
				</ul>

				<hr className="mb-3 mt-3" />

				<p>
					<a href="#">Tathmini ulinganifu wako</a> nasi tutakuambia jinsi ufaavyo kwa kazi hii.
				</p>
			</>
		) : (
			<p className="mt-1">Hakuna maelezo ya majukumu ya kazi hii.</p>
		);

	return (
		<RoleAccordion
			title={loading ? "Loading Role Explainer ...." : "Role Explainer"}
			content={{
				en: loading ? <p>Loading...</p> : enContent,
				sw: swContent,
			}}
		/>
	);
}

export default RoleExplainer;
